export const docxMimeTypes = [
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document; version="2007 onwards"',
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template; version="2007 onwards"',
];
